module.exports = __webpack_public_path__ + "img/logo_stadt_passau.ea420f6.png";